import { css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ItemTable } from '../../library/abstracts/item-table.js';
import type { TableItemsAssets } from './table-items-assets';

/**
 *
 * STATUS OK
 */
@customElement('d-assets-table')
export class DAssetsTable extends ItemTable<TableItemsAssets> {
  static readonly styles = [
    ...ItemTable.styles,
    css`
      :host {
        display: block;
      }

      .legends {
        display: inline-block;
        font-weight: normal;
      }

      .legend {
        display: inline-block;
        padding-left: 24px;
        padding-right: 6px;
        background-size: 22px auto;
        background-repeat: no-repeat;
        background-position: 0 -2px;
      }

      .legend.done {
        background-image: url(/images/check-mini-gray.svg);
      }

      .legend.ok {
        background-image: url(/images/check-mini-blue.svg);
      }

      .legend.not-ok {
        background-image: url(/images/x-fat-orange.svg);
      }

      tr.tasks td,
      tr.events td {
        cursor: default;
      }

      div.date {
        display: inline-block;
      }

      .subitem:not(.alert) > td {
        padding-top: 9px;
        color: hsla(0, 0%, 0%, 0.8);
      }

      .prev-next:first-child {
        margin-top: 4px;
      }

      .prev-next d-label {
        width: 60px;
      }

      .prev-next span,
      .prev-next a {
        padding-left: 24px;
      }

      .event-done a,
      .asset-ok a,
      .asset-not-ok a {
        background-size: 22px auto;
        background-repeat: no-repeat;
        background-position: 0 -2px;
        color: var(--linkColorGray);
      }

      .event-done a {
        background-image: url(/images/check-mini-gray.svg);
      }

      .asset-ok a {
        background-image: url(/images/check-mini-blue.svg);
      }

      .asset-not-ok a {
        background-image: url(/images/x-fat-orange.svg);
      }
    `,
  ];

  protected get entityType() {
    return 'assets';
  }

  includeItem(item: TableItemsAssets): boolean {
    return this.filterFields(item.name, item.category, item.location, item.number);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-assets-table': DAssetsTable;
  }
}
